<template>
  <div class="panel-body">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>{{ formText }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog2" max-width="750px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ "Add New Bank Account" }}</span>
        </v-card-title>

        <v-container>
          <v-row class="px-2">
            <v-col>
              <v-text-field
                v-model="newBank.branchNumber"
                label="Institution Number"
                required
                single-line
                :rules="branchRules"
                clearable
                persistent-hint
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="px-2">
            <v-col>
              <v-text-field
                v-model="newBank.transitNumber"
                label="Transit Number"
                single-line
                :rules="transitNumRules"
                clearable
                persistent-hint
                required
                :disabled="disableTransitInput"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="px-2">
            <v-col>
              <v-text-field
                v-model="newBank.accountNumber"
                label="Account Number"
                single-line
                :rules="accountNumRules"
                clearable
                persistent-hint
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="px-2">
            <v-col>
              <v-text-field
                v-model="newBank.bankName"
                label="Bank Name"
                single-line
                :rules="bankNameRules"
                clearable
                persistent-hint
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="!newBank.branchNumber || !newBank.transitNumber || !newBank.accountNumber || !newBank.bankName"
            @click="submitNewBank"
          >Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <template>
      <v-form>
        <v-container>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-col>
            <v-col>
              <v-layout justify-end>
                <v-btn txt @click="openAddBank">Add Bank</v-btn>
              </v-layout>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-card>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="accounts"
          :search="search"
          :loading="loadingAccounts"
          :key="test"
          item-key="id"
          class="elevation-1"
          :rows-per-page="rowsPerPage"
          :items-per-page-options="rppItems"
        >
          <template slot="item" slot-scope="props">
            <tr>
              <td class="text-xs-left">{{ props.item.active }}</td>
              <td class="text-xs-left">{{ props.item.branchNumber }}</td>
              <td class="text-xs-left">{{ props.item.transitNumber }}</td>
              <td class="text-xs-left">{{ props.item.maskedAccountNumber }}</td>
              <td class="text-xs-left">{{ props.item.bankName }}</td>
              <td class="text-xs-left">{{ props.item.verified }}</td>
              <td class="text-xs-left">{{ !props.item.canEdit }}</td>
              <td class="text-xs-left">{{ props.item.createdDate }}</td>
              <td class="text-xs-left">{{ props.item.updatedDate }}</td>
              <td class="text-xs-left">{{ props.item.pennyDeposit }}</td>
              <td class="justify-center layout px-0">
                <!-- <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> -->
                <v-icon :disabled="!props.item.active" small @click="deleteItem(props.item)">delete</v-icon>
              </td>
            </tr>
          </template>
          <template slot="no-data"></template>
        </v-data-table>
      </v-card>
    </template>
  </div>
</template>

<script>
let rh = require('@/components/APIs/RequestHandler')

export default {
  props: {
    user: {
      required: true
    }
  },
  data: () => ({
    loadingAccounts: false,
    search: '',
    rppItems: [
      10,
      50,
      100,
      { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 }
    ],
    rowsPerPage: 10,
    test: 0,
    selected: [],
    errors: [],
    dialog: false,
    dialog2: false,

    headers: [
      { text: 'Active', align: 'left', value: 'active' },
      { text: 'Institution', value: 'branchNumber' },
      { text: 'Transit', value: 'transitNumber' },
      { text: 'Account', value: 'maskedAccountNumber' },
      { text: 'Bank', value: 'bankName' },
      { text: 'Verified', value: 'verified' },
      { text: 'Has Txns', value: 'canEdit' },
      { text: 'Created Date', value: 'createdDate' },
      { text: 'Updated Date', value: 'updatedDate' },
      { text: 'Penny Deposit', value: 'pennyDeposit' }
    ],
    accounts: [],
    newBank: {},
    bankNameRules: [v => !!v || 'This is required'],
    branchRules: [
      v => !!v || 'This is required',
      v => /^\d+$/.test(v) || 'This must contain only digits',
      v => (v && v.length === 3) || 'This must be 3 digits'
    ],
    transitNumRules: [
      v => !!v || 'This is required',
      v => /^\d+$/.test(v) || 'This must contain only digits',
      v => (v && v.length === 5) || 'This must be 5 digits'
    ],
    accountNumRules: [
      v => !!v || 'This is required',
      v => /^\d+$/.test(v) || 'This must contain only digits',
      v => (v && v.length >= 7 && v.length <= 12) || 'This must be 7-12 digits'
    ],
    availInstitutions: [],
    disabledTransitInput: false
  }),
  computed: {
    formTitle () {
      if (this.user === undefined || this.user == null) {
        return 'Bank Accounts'
      } else {
        return 'Bank Accounts for ' + this.user.quberUserName
      }
    },
    formText () {
      if (
        this.selected == null ||
        this.selected.length < 1 ||
        this.selected[0] == null
      ) {
        return 'Nothing'
      } else {
        return 'Bank Account: \'' + this.selected[0].id + '\''
      }
    },
    disableTransitInput () {
      return this.disabledTransitInput
    }
  },
  created () {
    this.loadBankAccounts()
    // this.loadInstitutions()
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    user: {
      immediate: true,
      deep: true,
      handler (newValue, oldValue) {
        this.loadBankAccounts()
      }
    }
  },

  methods: {
    async selectAccount (a) {
      this.dialog = true
      this.selected = [a]
    },
    async loadInstitutions () {
      // Get available institutions
      const endpoint = `${process.env.VUE_APP_QUBER_SERVICE_FAS}/available-institutions`
      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (
        getResponse !== undefined &&
        getResponse.data !== undefined &&
        getResponse.data.length > 0
      ) {
        this.availInstitutions = getResponse.data.filter(i => {
          return i.primaryAccountEnabled === true
        })
      }
    },
    async loadBankAccounts () {
      this.accounts = []
      if (
        this.user == null ||
        this.user.userId == null ||
        this.user.userId === ''
      ) {
        return
      }
      this.loadingAccounts = true
      var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_BANK}/all-bank-accounts?owner=${this.user.userId}`

      var getResponse = await rh.default.get(endpoint, true).catch(e => {
        this.errors.push(e)
      })
      if (
        getResponse !== undefined &&
        getResponse.data !== undefined &&
        getResponse.data.length > 0
      ) {
        this.accounts = getResponse.data
      }
      this.loadingAccounts = false
    },
    editItem (item) {
      this.editedIndex = this.accounts.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    async deleteItem (item) {
      const index = this.accounts.indexOf(item)
      if (confirm('Are you sure you want to deactivate this account?')) {
        var endpoint = `${process.env.VUE_APP_QUBER_SERVICE_BANK}/bank-accounts/${this.accounts[index].id}/deactivate`

        var putResponse = await rh.default
          .put(endpoint, this.accounts[index], true)
          .catch(e => {
            this.errors.push(e)
          })

        if (putResponse !== undefined && putResponse.status === 200) {
          this.accounts[index].active = false
        } else alert('Failed to deactivate account')
      }
    },
    close () {
      this.dialog = false
      this.dialog2 = false
    },
    openAddBank () {
      if (confirm('Adding this bank will deactivate other ones. Proceed?')) {
        this.dialog2 = true
      }
    },
    async submitNewBank () {
      var activeAccount = await this.accounts.filter(account => {
        return account.active === true
      })

      // Deactivate bank accounts that are active
      if (this.accounts.indexOf(activeAccount[0]) !== -1) {
        await this.deleteItem(activeAccount[0])
      }

      // Make PUT request for new bank information
      var bankInformation = {
        owner: this.user.userId,
        accountNumber: this.newBank.accountNumber,
        branchNumber: this.newBank.branchNumber,
        transitNumber: this.newBank.transitNumber,
        bankName: this.newBank.bankName
      }

      const endpoint = `${process.env.VUE_APP_QUBER_SERVICE_BANK}/bank-accounts?requiresVerification=false`
      var postResponse

      postResponse = await rh.default
        .put(endpoint, bankInformation, true)
        .catch(e => {
          this.errors.push(e)
        })

      // Add the newly created bank to list of bank accounts
      this.accounts.push(postResponse.data)
      this.test++
      this.close()
    },
    setTransitNum (value) {
      // Autofill bank name
      this.newBank.bankName = value.name

      // Check if the bank only has 1 transit number
      var filteredBanks = this.availInstitutions.filter(i => {
        return i.name === value.name
      })

      // Only 1 transit Number, autoset it
      if (filteredBanks.length === 1 && filteredBanks[0].transitNumber != null) {
        this.newBank.transitNumber = filteredBanks[0].transitNumber
        this.disabledTransitInput = true
      } else {
        this.newBank.transitNumber = ''
        this.disabledTransitInput = false
      }
    }
  }
}
</script>
<style>
</style>
